import { render, staticRenderFns } from "./bettwasche.vue?vue&type=template&id=1a2c4774&"
import script from "./bettwasche.vue?vue&type=script&lang=js&"
export * from "./bettwasche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2c4774')) {
      api.createRecord('1a2c4774', component.options)
    } else {
      api.reload('1a2c4774', component.options)
    }
    module.hot.accept("./bettwasche.vue?vue&type=template&id=1a2c4774&", function () {
      api.rerender('1a2c4774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HKG2OPqc1T14/JS/comp/bettwasche.vue"
export default component.exports